import { BoxFullWidth, ColumnBoxFlexFullWidth, ColumnFlexBox, FlexBox } from '../common/boxes';
import { ChangeEvent, useCallback, useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { TEXTS } from '../../core/texts';
import { ButtonWithLoader } from '../common/ButtonWithLoader';
import { Search } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { useQueryParamsState } from '../../hooks/useQueryParamsState';
import { BaseObj } from '../../types/baseObj';
import ClientInfo from './ClientInfo';
import ProjectOpportunitiesTable from './ProjectOpportunitiesTable';
import CreateProjectOpportunity from './create-project-opportunity/CreateProjectOpportunity';
import { useGetClientProjectOpportunities } from '../../queryHooks/client/useGetClientProjectOpportunities';

export interface IProjectOpportunityState extends BaseObj {
  clientId: number | null;
}

const initialState: IProjectOpportunityState = { clientId: null };

const ProjectOpportunities = () => {
  const theme = useTheme();
  const [state, setState] = useState<IProjectOpportunityState>(initialState);
  const { queryParamState, isPrePopulated } = useQueryParamsState({ state, setState });
  const { data: projects, isFetching } = useGetClientProjectOpportunities({ clientId: state.clientId });

  const handleSearchBtn = useCallback((e: ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setState(prev => ({ ...initialState, clientId: e.target.clientId.valueAsNumber }));
  }, []);

  return (
    <ColumnBoxFlexFullWidth>
      <Box mb={{ mobile: 3.5, tablet: 2 }} alignSelf={{ mobile: 'center', tablet: 'flex-end' }}>
        <CreateProjectOpportunity clientId={queryParamState.clientId} />
      </Box>
      <ColumnBoxFlexFullWidth borderBottom={1} pb={2} borderColor={theme.palette.primary.main}>
        <form onSubmit={handleSearchBtn}>
          <ColumnFlexBox>
            <FlexBox alignItems={'center'} alignContent={'center'}>
              {
                isPrePopulated &&
                <TextField name={'clientId'} label={TEXTS.CLIENT_ID} required type={'number'}
                           defaultValue={queryParamState.clientId}
                           InputProps={{ inputProps: { min: 0 } }}
                           sx={{ mr: { mobile: 1, laptop: 2 } }}
                />
              }
              <Box>
                <ButtonWithLoader loading={isFetching} type={'submit'} startIcon={<Search/>}>
                  {TEXTS.SEARCH}
                </ButtonWithLoader>
              </Box>
            </FlexBox>

            {
              !!state.clientId &&
              <Box mt={2}>
                <ClientInfo clientId={state.clientId}/>
              </Box>
            }

          </ColumnFlexBox>
        </form>
      </ColumnBoxFlexFullWidth>
      {
        projects &&
        <BoxFullWidth mt={4}>
          {
            !!projects.length && state.clientId
              ? <ProjectOpportunitiesTable projects={projects} clientId={state.clientId}/>
              : <Typography>{TEXTS.NO_RECORDS_FOUND}</Typography>
          }
        </BoxFullWidth>
      }
    </ColumnBoxFlexFullWidth>
  );
};

export default ProjectOpportunities;